module.exports = __webpack_public_path__ + "img/modal-experiencia-3.1d4165cd.svg";